import { IRequirementModel } from '../../../../../../../service/requirement/entity/IRequirementModel';
import { IRequirementService } from '../../../../../../../service/requirement/entity/IRequirementService';
import { IRowContextMenuUI } from '../../../../../../design/dataTable/parts/rowContextMenu/domain/IRowContextMenuUI';
import { RowContextMenuDomain } from '../../../../../../design/dataTable/parts/rowContextMenu/domain/RowContextMenuDomain';
import { IDataTableDomain } from '../../../../../../design/dataTable/store/IDataTableDomain';
import { IMainLayoutDomainStore } from '../../../../../../layout/main/store/domain/IMainLayoutDomainStore';
import { RequirementEntityContextMenuUI } from './RequirementEntityContextMenuUI';

export class RequirementEntityContextMenuDomain extends RowContextMenuDomain<IRequirementModel> {
  constructor({
    entityService,
    dataTableDomain,
    layoutDomain,
    ui,
  }: {
    entityService: IRequirementService;
    dataTableDomain: IDataTableDomain<IRequirementModel, any>;
    layoutDomain: IMainLayoutDomainStore;
    ui?: IRowContextMenuUI<IRequirementModel> | null;
  }) {
    super(entityService, dataTableDomain, layoutDomain, undefined, ui);
    this.ui = ui || new RequirementEntityContextMenuUI(this);
  }

  async onEditRowInDrawer(row: any): Promise<void> {
    await super.onEditRowInDrawer(row);
    this.dataTableDomain.drawerDomain.ui.isEditMode.setValue(true);
  }
}
